exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-step-2-tsx": () => import("./../../../src/pages/step2.tsx" /* webpackChunkName: "component---src-pages-step-2-tsx" */),
  "component---src-pages-step-3-tsx": () => import("./../../../src/pages/step3.tsx" /* webpackChunkName: "component---src-pages-step-3-tsx" */),
  "component---src-pages-step-4-tsx": () => import("./../../../src/pages/step4.tsx" /* webpackChunkName: "component---src-pages-step-4-tsx" */)
}

